module.exports = __webpack_public_path__ + "static/media/boat-img-37.553e181e.jpg";